import Vue from 'vue'
import Format from '../utility/Format'
import LaneClosureRequestListEntry from '../models/LaneClosureRequestListEntry'
import createBlockMarker from "../utility/BlockMarker.js";
export default {
	namespaced: true,
	state: {
		ref: null,
		placesService: null,
		map: null,
		myLocation: null,
		searchLocation: null,
		fromDate: null,
		toDate: null,
		lcrFromDate: null,
		lcrToDate: null,
		polylines: [],
		nearbyPolylines: [],
		blockRequests: [],
		requests: [],
		markers: [],
		gMapMarkers: [],
		markerLayer: null,
		zIndex: 2000000,
		nearbyRadius: 1000, // distance in meters around the request's boundaries to fetch nearby requests.
		activeLcrId: null,
		zoomFixed: false,
		bounds: null,
		nearbyBounds: null,
		canLoadNearbyBounds: false,
	},
	getters: {
		activeLcrId: state => {
			return state.activeLcrId;
		},
		bounds: state => {
			return state.bounds;
		},
		nearbyRadius: state => {
			return state.nearbyRadius;
		},
		nearbyBounds: state => {
			return state.nearbyBounds;
		},
		canLoadNearbyBounds: state => {
			return state.canLoadNearbyBounds;
		},

		polylines: state => {
			return state.polylines;
		},
		blockRequests: state => {
			return state.blockRequests;
		},
		zoom: state => {
			return state.map.zoom;
		},
		zoomFixed: state => {
			return state.zoomFixed;
		},
		map: state => {
			return state.map;
		},

		markers: state => {
			return state.markers;
		},
		myLocation: state => {
			return state.myLocation;
		},
		searchLocation: state => {
			return state.searchLocation;
		},
		fromDate: state => {
			return state.fromDate;
		},
		toDate: state => {
			return state.toDate;
		},
		lcrFromDate: state => {
			return state.lcrFromDate;
		},
		lcrToDate: state => {
			return state.lcrToDate;
		},

		nearbyPolylines: state => {
			return state.nearbyPolylines;
		},

		zIndex: state => {
			return state.zIndex;
		},

	},
	mutations: {

		loadNearbyBoundedSuccess(state, payload) {
			var found = false;
			var zz = 0;

			if (payload.data) {
				if (payload.data.length == 0) {
					return;
				}
			} else {
				return;
			}

			if (payload.conflicts != null) {
				for (var z = 0; z < payload.conflicts.length; z++) {
					for (var i = 0; i < payload.data.length; i++) {
						if (payload.conflicts[z].lcrId == payload.data[i].id) {
							// don't double up the conflicts...
							found = false;
							for (zz = 0; zz < payload.data[i].conflicts.length; zz++) {
								if (payload.data[i].conflicts[zz].lcrId == payload.data[i].id) {
									found = true;
								}
							}
							if (!found) {
								payload.data[i].conflicts.push(payload.conflicts[z]);
							}
						}
					}
					for (var y = 0; y < payload.mapData.length; y++) {
						if (payload.conflicts[z].lcrId == payload.mapData[y].id) {
							payload.mapData[y].conflicts.push(payload.conflicts[z]);

							// don't double up the conflicts...
							found = false;
							for (zz = 0; zz < payload.mapData[y].conflicts.length; zz++) {
								if (payload.mapData[y].conflicts[zz].lcrId == payload.mapData[y].id) {
									found = true;
								}
							}
							if (!found) {
								// payload.data[i].conflicts.push(payload.conflicts[z]);
								payload.mapData[y].conflicts.push(payload.conflicts[z]);

							}

						}
					}
				}
			}

			let bIndex = 0;
			let testId = 0;
			let x = 0;
			// let ignore = 0;
			if (payload.data) {
				// loop through the existing polylines and remove the loaded data entries if we found the requests.
				if (state.nearbyPolylines) {
					for (x = 0; x < state.nearbyPolylines.length; x++) {
						if (typeof state.nearbyPolylines[x] != "undefined") {
							for (y = 0; y < payload.data.length; y++) {
								if (payload.data[y] != null) {
									if (payload.data[y].id == state.nearbyPolylines[x].lcrId) {
										found = true;
										payload.data[y] = null;
									}
								}
							}
						}
					}
				}
				for (x = 0; x < payload.data.length; x++) {
					if (payload.data[x] != null) {
						var laneClosureRequest = new LaneClosureRequestListEntry(payload.data[x]);

						let color = "#000000";
						let opacity = 1.0;
						let weight = 8;

						if (payload.data[x].approvalStatusId == 1) {
							// pending
							color = "#00aa00";
							opacity = 1;
							weight = 6;
						}
						if (payload.data[x].approvalStatusId == 2) {
							// approved
							// see if any of the
							// active
							if (payload.data[x].closureActiveStatusId == 2 || payload.data[x].restrictionActiveStatusId == 2) {
								if (payload.data[x].block) {
									color = "#ff7314";
									let i = 0;
									for (i = 0; i < payload.data[x].block.length; i++) {
										if (payload.data[x].block[i].lane) {
											for (let j = 0; j < payload.data[x].block[i].lane.length; j++) {
												// complete closure of street / direction
												if (payload.data[x].block[i].lane[j].laneId == 13 ||
													payload.data[x].block[i].lane[j].laneId == 14) {
													// color = "#ed1c24";
												}
											}
										}
									}
								}
							} else {
								color = "#00aa00";
								if (payload.data[x].closureActiveStatusId == 1 || payload.data[x].restrictionActiveStatusId == 1) {
									// planned...
									color = "#ffff00";
								}
								if (payload.data[x].closureActiveStatusId == 3 || payload.data[x].restrictionActiveStatusId == 3) {
									// expired
									color = "#cc0505";
								} else {
									if (payload.data[x].completeTypeId != null) {
										if (payload.data[x].closureActiveStatusId == 4 || payload.data[x].restrictionActiveStatusId == 4) {
											// completed
											color = "#0000ff";
										}
									}
								}
							}

							if (payload.data[x].recordStatusId == 6) {
								// approved, but expired...
								color = "#cc0505";
							}
						}
						if (payload.data[x].approvalStatusId == 3) {
							// denied
						}
						if (color == "#666666") {
							// console.log(payload);
							// console.log(color);
						}
						if (payload.data[x].block) {
							for (var xx = 0; xx < payload.data[x].block.length; xx++) {
								var coords = Format.getKmlCoords(payload.data[x].block[xx]);

								testId = payload.data[x].block[xx].blockId;
								bIndex = state.blockRequests.findIndex(z => z.id === testId);
								if (bIndex > -1) {
									weight = weight * state.blockRequests[bIndex].total;
								}
								// weight = 1;
								if (weight < 1) {
									weight = 1;
								}
								if (weight > 1) {
									// console.log(weight);
								}
								let mapPolyline = new google.maps.Polyline({
									map: state.map,
									path: coords,
									strokeColor: color,
									strokeOpacity: opacity,
									strokeWeight: weight
								});
								mapPolyline.blockData = payload.data[x].block[xx];
								mapPolyline.blockId = payload.data[x].block[xx].blockId;
								mapPolyline.lcrId = laneClosureRequest.id;
								mapPolyline.laneClosureRequest = laneClosureRequest;
								google.maps.event.addListener(mapPolyline, 'click', function(e) {
									Vue.prototype.$bus.$emit('map:nearby-block-popup', {
										polyline: this,
										e: e
									});
								});
								state.nearbyPolylines.push(mapPolyline);


								var latlngs = [];
								for (var i = 0; i < coords.length; i++) {// eslint-disable-line
									latlngs.push(new google.maps.LatLng(coords[i].lat, coords[i].lng));
								}

								var foo = Format.lineMidpoint(latlngs);
								if (payload.data[x].block[xx].blockId) {
									if (laneClosureRequest.conflicts.length > 0) {
										this.commit("map/addBlockRequest", {
											id: payload.data[x].block[xx].blockId,
											coords: latlngs,
											midpoint: foo,
											conflictCount: laneClosureRequest.conflicts.length,
											requestId: laneClosureRequest.id
										});
									} else {
										this.commit("map/addBlockRequest", {
											id: payload.data[x].block[xx].blockId,
											coords: latlngs,
											midpoint: foo,
											conflictCount: laneClosureRequest.conflicts.length,
											requestId: laneClosureRequest.id
										});
									}
								}
							}
						}
					// } else {
						// ignore++;
					}
				}
				let latlng = null;


				for (x = 0; x < state.blockRequests.length; x++) {
					if (state.blockRequests[x].total > 1) {
						if (payload.position) {
							latlng = new google.maps.LatLng(
								parseFloat(payload.position.lat()),
								parseFloat(payload.position.lng()));
							new google.maps.Marker({
								position: latlng,
								map: this.map,
								title: "" + state.blockRequests[x].total,
							});
						}
					}
				}
			}
			// console.log("payload.data:" + payload.data.length);
			// console.log("state.nearbyPolylines:" + state.nearbyPolylines.length);
			// console.log("ignore:" + ignore);
			Vue.prototype.$bus.$emit('map:loading', false);
			Vue.prototype.$bus.$emit('map:nearbyLoaded', true);

		},


		loadNearbySuccess(state, payload) {

			if (payload.conflicts != null) {
				for (var z = 0; z < payload.conflicts.length; z++) {
					for (var i = 0; i < payload.data.length; i++) {
						if (payload.conflicts[z].lcrId == payload.data[i].id) {
							payload.data[i].conflicts.push(payload.conflicts[z]);
						}
					}
					for (var y = 0; y < payload.mapData.length; y++) {
						if (payload.conflicts[z].lcrId == payload.mapData[y].id) {
							payload.mapData[y].conflicts.push(payload.conflicts[z]);
						}
					}
				}
			}

			// now set the thickness of the line...
			// console.log("loadNearbySuccess");
			let bIndex = 0;
			// let y = 0;
			// let baseWeight = 8;
			// let newWeight = 0;
			let testId = 0;
			let x = 0;
			// let i = 0;
			if (payload.data) {
				if (state.nearbyPolylines) {
					for (x = 0; x < state.nearbyPolylines.length; x++) {
						if (typeof state.nearbyPolylines[x] != "undefined") {
							state.nearbyPolylines[x].setMap(null);
						}
					}
					state.nearbyPolylines = [];
				}

				// Set the line thicknesses of all the requests.
				// state.blockRequests = [];
				// for (x = 0; x < payload.data.length; x++) {
				// 	if (payload.data[x].block) {
				// 		for (i = 0; i < payload.data[x].block.length; i++) {
				// 			testId = payload.data[x].block[i].id;
				// 			bIndex = state.blockRequests.findIndex(z => z.id === testId);
				// 			if (bIndex == -1) {
				// 				state.blockRequests.push({
				// 					id: payload.data[x].block[i].id,
				// 					total: 1,
				// 				});
				// 			} else {
				// 				state.blockRequests[bIndex].total++;
				// 			}
				// 		}
				// 	}
				// }

				for (x = 0; x < payload.data.length; x++) {
					var laneClosureRequest = new LaneClosureRequestListEntry(payload.data[x]);

					let color = "#000000";
					let opacity = 1.0;
					let weight = 8;

					if (payload.data[x].approvalStatusId == 1) {
						// pending
						color = "#00aa00";
						opacity = 1;
						weight = 6;
					}
					if (payload.data[x].approvalStatusId == 2) {
						// approved
						// see if any of the
						// active
						if (payload.data[x].closureActiveStatusId == 2 || payload.data[x].restrictionActiveStatusId == 2) {
							if (payload.data[x].block) {
								color = "#ff7314";
								let i = 0;
								for (i = 0; i < payload.data[x].block.length; i++) {
									if (payload.data[x].block[i].lane) {
										for (let j = 0; j < payload.data[x].block[i].lane.length; j++) {
											// complete closure of street / direction
											if (payload.data[x].block[i].lane[j].laneId == 13 ||
												payload.data[x].block[i].lane[j].laneId == 14) {
												// color = "#ed1c24";
											}
										}
									}
								}
							}
						} else {
							color = "#00aa00";
							if (payload.data[x].closureActiveStatusId == 1 || payload.data[x].restrictionActiveStatusId == 1) {
								// planned...
								color = "#ffff00";
							}
							if (payload.data[x].closureActiveStatusId == 3 || payload.data[x].restrictionActiveStatusId == 3) {
								// expired
								color = "#cc0505";
							} else {
								if (payload.data[x].completeTypeId != null) {
									if (payload.data[x].closureActiveStatusId == 4 || payload.data[x].restrictionActiveStatusId == 4) {
										// completed
										color = "#0000ff";
									}
								}
							}
						}

						if (payload.data[x].recordStatusId == 6) {
							// approved, but expired...
							color = "#cc0505";
						}
					}
					if (payload.data[x].approvalStatusId == 3) {
						// denied
					}
					if (color == "#666666") {
						// console.log(payload);
						// console.log(color);
					}


					if (payload.data[x].block) {
						for (var xx = 0; xx < payload.data[x].block.length; xx++) {
							var coords = Format.getKmlCoords(payload.data[x].block[xx]);

							testId = payload.data[x].block[xx].blockId;
							bIndex = state.blockRequests.findIndex(z => z.id === testId);
							if (bIndex > -1) {
								weight = weight * state.blockRequests[bIndex].total;
							}
							// weight = 1;
							if (weight < 1) {
								weight = 1;
							}
							if (weight > 1) {
								// console.log(weight);
							}
							let mapPolyline = new google.maps.Polyline({
								map: state.map,
								path: coords,
								strokeColor: color,
								strokeOpacity: opacity,
								strokeWeight: weight
							});
							mapPolyline.blockData = payload.data[x].block[xx];
							mapPolyline.blockId = payload.data[x].block[xx].blockId;
							mapPolyline.lcrId = laneClosureRequest.id;
							mapPolyline.laneClosureRequest = laneClosureRequest;
							google.maps.event.addListener(mapPolyline, 'click', function(e) {
								Vue.prototype.$bus.$emit('map:nearby-block-popup', {
									polyline: this,
									e: e
								});
							});
							state.nearbyPolylines.push(mapPolyline);


							var latlngs = [];
							for (var i = 0; i < coords.length; i++) { // eslint-disable-line
								latlngs.push(new google.maps.LatLng(coords[i].lat, coords[i].lng));
							}

							var foo = Format.lineMidpoint(latlngs);
							if (payload.data[x].block[xx].blockId) {
								if (laneClosureRequest.conflicts.length > 0) {
									this.commit("map/addBlockRequest", {
										id: payload.data[x].block[xx].blockId,
										coords: latlngs,
										midpoint: foo,
										conflictCount: laneClosureRequest.conflicts.length,
										requestId: laneClosureRequest.id
									});
								} else {
									this.commit("map/addBlockRequest", {
										id: payload.data[x].block[xx].blockId,
										coords: latlngs,
										midpoint: foo,
										conflictCount: laneClosureRequest.conflicts.length,
										requestId: laneClosureRequest.id
									});
								}
							}
						}
					}
				}
				let latlng = null;


				for (x = 0; x < state.blockRequests.length; x++) {
					if (state.blockRequests[x].total > 1) {
						if (payload.position) {
							latlng = new google.maps.LatLng(
								parseFloat(payload.position.lat()),
								parseFloat(payload.position.lng()));
							new google.maps.Marker({
								position: latlng,
								map: this.map,
								title: "" + state.blockRequests[x].total,
							});
						}
					}
				}


			}

		},
		loadNearbyError(state) {},
		setDateRange(state, payload) {
			state.fromDate = payload.fromDate;
			state.toDate = payload.toDate;
		},
		setFromDate(state, payload) {
			state.fromDate = payload;
		},
		setToDate(state, payload) {
			state.toDate = payload;
		},
		setLcrFromDate(state, payload) {
			state.lcrFromDate = payload;
		},
		setLcrToDate(state, payload) {
			state.lcrToDate = payload;
		},
		setMyLocation(state, payload) {
			if (state.myLocation != null) {
				state.myLocation.setMap(null);
			}
			let latlng = new google.maps.LatLng(
				parseFloat(payload.position.lat()),
				parseFloat(payload.position.lng()));
			state.myLocation = new google.maps.Marker({
					map: state.map,
					position: latlng,
					animation: google.maps.Animation.DROP
				})
				// state.myLocation = payload;
		},
		setSearchLocation(state, payload) {
			if (state.searchLocation != null) {
				state.searchLocation.setMap(null);
			}
			state.searchLocation = payload;
		},
		setMap(state, payload) {
			state.map = payload;
		},
		setActiveLcrId(state, payload) {
			state.activeLcrId = payload;
		},
		setZIndex(state, payload) {
			state.zIndex = payload;
		},
		setRef(state, payload) {
			state.ref = payload;
		},
		setPlacesService(state, payload) {
			state.placesService = payload;
		},
		clearPolylines(state) {
			let x = 0;
			// if (state.polylines) {
			// 	while(state.polylines.length) { state.polylines.pop().setMap(null); }
			// }
			if (state.polylines) {
				for (x = 0; x < state.polylines.length; x++) {
					if (typeof state.polylines[x] != "undefined") {
						state.polylines[x].setMap(null);
					}
				}
				state.polylines = [];
			}

			if (state.nearbyPolylines) {
				for (x = 0; x < state.nearbyPolylines.length; x++) {
					if (typeof state.nearbyPolylines[x] != "undefined") {
						state.nearbyPolylines[x].setMap(null);
					}
				}
				state.nearbyPolylines = [];
			}
		},
		clearNearbyPolylines(state) {
			if (state.nearbyPolylines) {
				for (var x = 0; x < state.nearbyPolylines.length; x++) {
					if (typeof state.nearbyPolylines[x] != "undefined") {
						state.nearbyPolylines[x].setMap(null);
					}
				}
				state.nearbyPolylines = [];
			}
			state.nearbyBounds = null;
		},

		clearMarkers(state) {
			if (state.markers) {
				for (var x = 0; x < state.markers.length; x++) {
					if (typeof state.markers[x] != "undefined") {
						state.markers[x].setMap(null);
					}
				}
				state.markers = [];
			}
		},


		clearNearbyPolylinesAndMarkers(state) {
			var x = 0;
			if (state.nearbyPolylines) {
				for (x = 0; x < state.nearbyPolylines.length; x++) {
					if (typeof state.nearbyPolylines[x] != "undefined") {
						state.nearbyPolylines[x].setMap(null);
					}
				}
				state.nearbyPolylines = [];
			}
			state.nearbyBounds = null;
			if (state.markers) {
				for (x = 0; x < state.markers.length; x++) {
					if (typeof state.markers[x] != "undefined") {
						state.markers[x].setMap(null);
					}
				}
				state.markers = [];
			}
		},


		clearBlockDetailerMap(state) {
			// if (state.polylines) {
			// 	while(state.polylines.length) {
			// 		state.polylines.pop().setMap(null);
			// 	}
			// }
			let x = 0;
			state.fromDate = null;
			state.toDate = null;

			if (state.polylines) {
				for (x = 0; x < state.polylines.length; x++) {
					if (typeof state.polylines[x] != "undefined") {
						state.polylines[x].setMap(null);
					}
				}
				state.polylines = [];
			}

			if (state.nearbyPolylines) {
				for (x = 0; x < state.nearbyPolylines.length; x++) {
					if (typeof state.nearbyPolylines[x] != "undefined") {
						state.nearbyPolylines[x].setMap(null);
					}
				}
				state.nearbyPolylines = [];
			}

			if (state.map) {
				if (state.map.infoWindow) {
					state.map.infoWindow.close();
				}
			}

			state.blockRequests = [];
			if (state.markers) {
				for (x = 0; x < state.markers.length; x++) {
					if (typeof state.markers[x] != "undefined") {
						state.markers[x].setMap(null);
					}
				}
				state.markers = [];
			}
		},

		clearMap(state) {
			// if (state.polylines) {
			// 	while(state.polylines.length) {
			// 		state.polylines.pop().setMap(null);
			// 	}
			// }
			let x = 0;
			state.fromDate = null;
			state.toDate = null;

			if (state.polylines) {
				for (x = 0; x < state.polylines.length; x++) {
					if (typeof state.polylines[x] != "undefined") {
						state.polylines[x].setMap(null);
					}
				}
				state.polylines = [];
			}

			if (state.nearbyPolylines) {
				for (x = 0; x < state.nearbyPolylines.length; x++) {
					if (typeof state.nearbyPolylines[x] != "undefined") {
						state.nearbyPolylines[x].setMap(null);
					}
				}
				state.nearbyPolylines = [];
			}

			if (state.map) {
				if (state.map.infoWindow) {
					state.map.infoWindow.close();
				}
			}

			state.blockRequests = [];
			if (state.markers) {
				for (x = 0; x < state.markers.length; x++) {
					if (typeof state.markers[x] != "undefined") {
						state.markers[x].setMap(null);
						state.markers[x].remove();
						if (state.markers[x].getId()) {
							if (document.getElementById(state.markers[x].getId())) {
								document.getElementById(state.markers[x].getId()).remove();
							}
						}
					}
				}
				state.markers = [];
			}

			// now clear out any that are class name block-marker-wrapper because they hang around sometimes still.
			var orphanMarkers = document.getElementsByClassName("block-marker-wrapper");
			if (orphanMarkers.length > 0) {
				var i;
				for (i = 0; i < orphanMarkers.length; i++) {
					console.log("orphan marker");
					orphanMarkers[i].remove();
				}
			}

		},

		addMarker(state, marker) {
			state.markers.push(marker);
		},
		addPolyline(state, polyline) {
			state.zIndex = state.zIndex + 1;
			polyline.setOptions({
				zIndex: state.zIndex
			});
			state.polylines.push(polyline);
		},

		addBlockRequest(state, block) {
			if (block) {
				let bIndex = state.blockRequests.findIndex(z => z.id === block.id);
				if (bIndex == -1) {
					state.blockRequests.push({
						id: block.id,
						total: 1,
						conflictCount: block.conflictCount,
						maxConflictCount: block.conflictCount,
						coords: block.coords,
						midpoint: block.midpoint,
						requestId: block.requestId
					});
				} else {
					state.blockRequests[bIndex].total++;
					state.blockRequests[bIndex].conflictCount += block.conflictCount;
					if (typeof state.blockRequests[bIndex].requestId == "undefined") {
						state.blockRequests[bIndex].requestId = block.requestId;
					}
					if (block.conflictCount > 0) {
						if (block.conflictCount > state.blockRequests[bIndex].maxConflictCount) {
							state.blockRequests[bIndex].maxConflictCount = block.conflictCount;
							state.blockRequests[bIndex].requestId = block.requestId;
						}
					}

				}
			}
		},

		clearBlockRequest(state) {
			state.blockRequests = [];
			if (state.markers) {
				for (var x = 0; x < state.markers.length; x++) {
					if (typeof state.markers[x] != "undefined") {
						state.markers[x].setMap(null);
						state.markers[x].remove();
						if (state.markers[x].getId()) {
							if (document.getElementById(state.markers[x].getId())) {
								document.getElementById(state.markers[x].getId()).remove();
							}
						}

					}
				}
				state.markers = [];
			}
		},
		addNearbyPolyline(state, polyline) {
			state.zIndex = state.zIndex + 1;
			polyline.setOptions({
				zIndex: state.zIndex
			});
			state.nearbyPolylines.push(polyline);

		},
		addNumberMarkersForPolyline(state, index) {
			if (state.polylines[index]) {
				let path = state.polylines[index].getPath();
				let x = 0;
				if (state.map.map) {

					for (x = 0; x < path.length; x++) {
						// let marker = new google.maps.Marker({
						// 	setMap: state.map.map,
						// 	position: new google.maps.LatLng(path.getAt(x).lat(), path.getAt(x).lng()),
						// 	animation: google.maps.Animation.DROP
						// })
						let marker = createBlockMarker({
							latlng: new google.maps.LatLng(path.getAt(x).lat(), path.getAt(x).lng()),
							map: state.map.map,
							overlapCount: state.blockRequests[x].total,
							conflictCount: 0
						});

						state.markers.push(marker);
					}
				}

			}
		},


		addPolylineObject(state, obj) {
			let polyline = new google.maps.Polyline({
				map: state.map.map,
				path: obj.path,
				strokeColor: obj.color,
				strokeOpacity: obj.opacity,
				strokeWeight: obj.weight
			});
			if (obj.blockData) {
				polyline.blockData = obj.blockData;
			}
			state.polylines.push(polyline);
		},

		addNearbyPolylineObject(state, obj) {
			let polyline = new google.maps.Polyline({
				map: state.map.map,
				path: obj.path,
				strokeColor: obj.color,
				strokeOpacity: obj.opacity,
				strokeWeight: obj.weight
			});
			if (obj.blockData) {
				polyline.blockData = obj.blockData;
			}
			if (obj.laneClosureRequest) {
				polyline.laneClosureRequest = obj.laneClosureRequest;
			}
			state.nearbyPolylines.push(polyline);
		},
		setZoomFixed(state, fixed) {
			state.zoomFixed = fixed;
		},



		setZoom(state, zoom) {
			state.map.setZoom(zoom);
		},

		setCenter(state, zoom) {
			var pt = new google.maps.LatLng(49.895077, -97.138451);
			state.map.setCenter(pt);
		},

		setNearbyBounds(state, bounds) {
			state.nearbyBounds = bounds;
		},
		setLoadNearbyBounds(state, flag) {
			state.canLoadNearbyBounds = flag;
		},


		fitBounds(state, bounds) {
			state.bounds = bounds;
			setTimeout(function() {
				if (state.map) {
					state.map.fitBounds(bounds);
				}
			});
		},
		removePolyLineByBlockId(state, payload) {
			let x = 0;
			for (x = 0; x < state.polylines.length; x++) {
				if (state.polylines[x]) {
					if (state.polylines[x].blockData) {
						if (state.polylines[x].blockData.blockId == payload) {
							state.polylines[x].setMap(null);
							state.polylines.splice(x, 1);
							break;
						}
					}
				}
			}
		},

		removeNearbyPolyLineByBlockId(state, payload) {
			let x = 0;
			for (x = 0; x < state.nearbyPolylines.length; x++) {
				if (state.nearbyPolylines[x]) {
					if (state.nearbyPolylines[x].blockData) {
						if (state.nearbyPolylines[x].blockData.blockId == payload) {
							state.nearbyPolylines[x].setMap(null);
							state.nearbyPolylines.splice(x, 1);
							break;
						}
					}
				}
			}
		},



		setPolylineByIndex(state, index, polyline) {
			if (state.polylines[index]) {
				state.polylines[index].setMap(null);
			}
			state.polylines[index] = polyline;
		},


		setPolylineOptionsByIndex(state, index, options) {
			if (options) {
				state.polylines[index].setOptions(options);
			}
		},

		setPolylineShow(state, index) {
			if (state.polylines[index]) {
				state.polylines[index].setOptions({
					strokeOpacity:1,
				});
			}
		},

		setPolylineHide(state, index) {
			if (state.polylines[index]) {
				state.polylines[index].setOptions({
					strokeOpacity:0
				});
			}
		},

		setNearbyPolylineShow(state, index) {
			if (state.nearbyPolylines[index]) {
				state.nearbyPolylines[index].setOptions({
					strokeOpacity:1
				});
				// var x = 0;
				// if (state.markers) {
				// 	for (x = 0; x < state.markers.length; x++) {
				// 		if (typeof state.markers[x] != "undefined") {
				// 			if (state.markers[x].requestId == state.nearbyPolylines[index].laneClosureRequest.id) {
				// 				if (state.markers[x].getId()) {
				// 					if (document.getElementById(state.markers[x].getId())) {
				// 						console.log("showing marker");
				// 						document.getElementById(state.markers[x].getId()).style.display = "block";
				// 					}
				// 				}
				// 			}
				// 		}
				// 	}
				// }
			}
		},

		setNearbyPolylineHide(state, index) {
			if (state.nearbyPolylines[index]) {
				state.nearbyPolylines[index].setOptions({
					strokeOpacity:0
				});
				// var x = 0;
				// if (state.markers) {
				// 	for (x = 0; x < state.markers.length; x++) {
				// 		if (typeof state.markers[x] != "undefined") {
				// 			if (state.markers[x].requestId != state.nearbyPolylines[index].laneClosureRequest.id) {
				// 				if (state.markers[x].getId()) {
				// 					if (document.getElementById(state.markers[x].getId())) {
				// 						console.log("hiding marker");

				// 						document.getElementById(state.markers[x].getId()).style.display = "none";
				// 					}
				// 				}
				// 			}
				// 		}
				// 	}
				// }
			}
		},

		setPolylineMaxZIndex(state, index) {
			if (state.polylines[index]) {
				state.zIndex = state.zIndex + 1;
				state.polylines[index].setOptions({
					zIndex: state.zIndex
				});
			}
		},

		setNearbyPolylineMaxZIndex(state, index) {
			if (state.nearbyPolylines[index]) {
				state.zIndex = state.zIndex + 1;
				state.nearbyPolylines[index].setOptions({
					zIndex: state.zIndex
				});
			}
		},


		setNearbyPolylineByIndex(state, index, polyline) {
			if (state.nearbyPolylines[index]) {
				state.nearbyPolylines[index].setMap(null);
			}
			state.nearbyPolylines[index] = polyline;
		},
		clearOverlapIcons(state) {
			let x = 0;
			if (state.markers) {
				for (x = 0; x < state.markers.length; x++) {
					if (typeof state.markers[x] != "undefined") {
						if (state.markers[x].conflictCount > 0) {
							// don't remove conflict icons.
						} else {
							state.markers[x].setMap(null);
							state.markers[x].remove();
							if (state.markers[x].getId()) {
								if (document.getElementById(state.markers[x].getId())) {
									document.getElementById(state.markers[x].getId()).remove();
								}
							}
							state.markers.splice(x, 1);
						}
					}
				}

				// doing it twice seems to force the browser to clear all markers.
				for (x = 0; x < state.markers.length; x++) {
					if (typeof state.markers[x] != "undefined") {
						if (state.markers[x].conflictCount > 0) {
							// don't remove conflict icons.
						} else {
							state.markers[x].setMap(null);
							state.markers[x].remove();
							if (state.markers[x].getId()) {
								if (document.getElementById(state.markers[x].getId())) {
									document.getElementById(state.markers[x].getId()).remove();
								}
							}
							state.markers.splice(x, 1);
						}
					}
				}
			}
		},

		buildOverlapIcons(state) {
			let x = 0;
			if (state.markers) {
				for (x = 0; x < state.markers.length; x++) {
					if (typeof state.markers[x] != "undefined") {
						state.markers[x].setMap(null);
						state.markers[x].remove();
						if (state.markers[x].getId()) {
							if (document.getElementById(state.markers[x].getId())) {
								document.getElementById(state.markers[x].getId()).remove();
							}
						}

					}
				}
				state.markers = [];
			}
			for (x = 0; x < state.blockRequests.length; x++) {
				if (state.blockRequests[x].total > 1) {
					// if (state.blockRequests[x].conflictCount > 0) {
					// 	console.log(state.blockRequests[x]);
					// }

					if (state.blockRequests[x].midpoint) {
						// console.log(state.blockRequests[x].requestId);
						var marker = createBlockMarker({
							latlng: new google.maps.LatLng(state.blockRequests[x].midpoint.lat, state.blockRequests[x].midpoint.lng),
							map: this.state.map.map,
							overlapCount: state.blockRequests[x].total,
							conflictCount: state.blockRequests[x].conflictCount,
							requestId: state.blockRequests[x].requestId,
							blockId: state.blockRequests[x].id
						});
						google.maps.event.addListener(marker, 'click', function(e) {
							window.popupRequest(this.requestId);
						});
						state.markers.push(marker);
					}
				}
			}
		},

		setAllNearbyPolylineWeight(state) {
			let x = 0;
			// let z = 0;
			let bIndex = 0;
			let weight = 8;
			let weights = new Array(
				8,
				8,
				12,
				14,
				16,
				18,
				20,
				22,
				24,
				28,
				30,
				32,
				40,
				50,
				60
			);

			// for (x = 0; x < state.blockRequests.length; x++) {
			// 	state.blockRequests[x].total = 0;
			// }
			// for (x = 0; x < state.nearbyPolylines.length; x++) {
			// 	if (state.nearbyPolylines[x]) {
			// 		if (state.nearbyPolylines[x].blockData) {
			// 			bIndex = state.blockRequests.findIndex(z => z.id === state.nearbyPolylines[x].blockData.blockId);
			// 			if (bIndex == -1) {
			// 				state.blockRequests.push({
			// 					id: state.nearbyPolylines[x].blockData.blockId,
			// 					total: 1
			// 				});
			// 			} else {
			// 				state.blockRequests[bIndex].total++;
			// 			}
			// 		}
			// 	}
			// }

			for (x = 0; x < state.nearbyPolylines.length; x++) {
				if (state.nearbyPolylines[x]) {
					if (state.nearbyPolylines[x].blockData) {
						bIndex = state.blockRequests.findIndex(z => z.id === state.nearbyPolylines[x].blockData.blockId);
						if (bIndex > -1) {
							if (bIndex > 10) {
								weight = 8 * state.blockRequests[bIndex].total;
							} else {
								weight = weights[state.blockRequests[bIndex].total];
							}
							if (weight > 80) {
								weight = 80;
							}
							// temporarily set weight to 8.
							weight = 8;
							this.getters["map/nearbyPolylines"][x].setOptions({
								strokeWeight: weight
							});
						} else {
							this.getters["map/nearbyPolylines"][x].setOptions({
								strokeWeight: 8
							});
						}
					}
				}
			}


			// for (x = 0; x < state.nearbyPolylines.length; x++) {
			// 	if (state.nearbyPolylines[x]) {
			// 		if (state.nearbyPolylines[x].blockData) {
			// 			bIndex = state.blockRequests.findIndex(z => z.id === state.nearbyPolylines[x].blockData.blockId);
			// 			if (bIndex == -1) {
			// 				state.blockRequests.push({
			// 					id: state.nearbyPolylines[x].blockData.blockId,
			// 					total: 1
			// 				});
			// 			} else {
			// 				state.blockRequests[bIndex].total++;
			// 			}
			// 		}
			// 	}
			// }



		},

		setPolylineBlockDataByIndex(state, index, data) {
			if (state.polylines[index]) {
				state.polylines[index].blockData = data;
			}
		},

		setNearbyPolylineBlockDataByIndex(state, index, data) {
			if (state.nearbyPolylines[index]) {
				state.nearbyPolylines[index].blockData = data;
			}
		},


		setMarkerByIndex(state, index, marker) {
			if (state.markers[index]) {
				state.markers[index].setMap(null);
			}
			state.markers[index] = marker;
		},
	},
	actions: {
		setActiveLcrId({
			commit
		}, id) {
			commit('setActiveLcrId', id);
		},

		buildOverlapIcons({
			commit
		}) {
			commit('buildOverlapIcons');
		},

		clearOverlapIcons({
			commit
		}) {
			commit('clearOverlapIcons');
		},


		addBlockRequest({
			commit
		}, block) {
			commit('addBlockRequest', block);
		},



		clearBlockRequest({
			commit
		}, block) {
			commit('clearBlockRequest', block);
		},

		setAllNearbyPolylineWeight({
			commit
		}) {
			commit('setAllNearbyPolylineWeight');
		},

		setLcrDateRange({
			commit
		}, dates) {
			commit('setLcrFromDate', Vue.prototype.moment(dates.fromDate));
			commit('setLcrToDate', Vue.prototype.moment(dates.toDate));
		},

		zoomAllBlocks({
			commit
		}, id) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			let x = 0;
			let z = 0;
			for (x = 0; x < this.getters["map/polylines"].length; x++) {
				if (this.getters["map/polylines"][x]) {
					let polyBounds = this.getters["map/polylines"][x].getPath();
					for (z = 0; z < polyBounds.length; z++) {
						bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
					}
					setBounds = true;
				}
			}
			if (setBounds) {
				commit('fitBounds', bounds);
			} else {
				if (this.getters["map/zoom"] <= 3 && !this.getters["map/zoomFixed"]) {
					commit('setZoomFixed', true);
					commit('setZoom', 16);
					commit('setCenter', 49.895077, -97.138451);
				}
			}
		},
		zoomToBlockId({
			commit
		}, id) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			let x = 0;
			let z = 0;
			for (x = 0; x < this.getters["map/polylines"].length; x++) {
				if (this.getters["map/polylines"][x]) {
					if (this.getters["map/polylines"][x].blockData) {
						if (this.getters["map/polylines"][x].blockData.blockId == id) {
							let polyBounds = this.getters["map/polylines"][x].getPath();
							for (z = 0; z < polyBounds.length; z++) {
								bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
							}
							setBounds = true;
						}
					}
				}
			}
			if (setBounds) {
				commit('fitBounds', bounds);
			}
		},

		zoomToMyLocation({
			commit
		}, id) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			let loc = this.getters["map/myLocation"];
			if (loc) {
				bounds.extend(new google.maps.LatLng(loc.position.lat(), loc.position.lng()));
				setBounds = true;
				if (setBounds) {
					commit('fitBounds', bounds);
				}
			}
		},
		zoomToSearchLocation({
			commit
		}, id) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			let loc = this.getters["map/searchLocation"];
			if (loc) {
				bounds.extend(new google.maps.LatLng(loc.position.lat(), loc.position.lng()));
				setBounds = true;
				if (setBounds) {
					commit('fitBounds', bounds);
				}
			}
		},

		setZindexesForPolylines({
			commit
		}) {
			let x = 0;

			// bring pending to the top first.
			for (x = 0; x < this.getters["map/nearbyPolylines"].length; x++) {
				if (this.getters["map/nearbyPolylines"][x]) {
					if (this.getters["map/nearbyPolylines"][x].approvalStatusId == 1) {
						commit('setNearbyPolylineMaxZIndex', x);
					}
				}
			}
			// bring upcoming (planned) next
			for (x = 0; x < this.getters["map/nearbyPolylines"].length; x++) {
				if (this.getters["map/nearbyPolylines"][x]) {
					if (this.getters["map/nearbyPolylines"][x].approvalStatusId == 2 &&
						(this.getters["map/nearbyPolylines"][x].closureActiveStatusId == 1 || this.getters["map/nearbyPolylines"][x].restrictionActiveStatusId == 1)
					) {
						commit('setNearbyPolylineMaxZIndex', x);
					}
				}
			}


			// bring expired next
			for (x = 0; x < this.getters["map/nearbyPolylines"].length; x++) {
				if (this.getters["map/nearbyPolylines"][x]) {
					if (this.getters["map/nearbyPolylines"][x].approvalStatusId == 2 &&
						(this.getters["map/nearbyPolylines"][x].recordStatusId == 7)
					) {
						commit('setNearbyPolylineMaxZIndex', x);
					}
				}
			}


			// bring current next
			for (x = 0; x < this.getters["map/nearbyPolylines"].length; x++) {
				if (this.getters["map/nearbyPolylines"][x]) {
					if (this.getters["map/nearbyPolylines"][x].approvalStatusId == 2 &&
						(this.getters["map/nearbyPolylines"][x].closureActiveStatusId == 2 || this.getters["map/nearbyPolylines"][x].restrictionActiveStatusId == 2)
					) {
						commit('setNearbyPolylineMaxZIndex', x);
					}
				}
			}



		},

		filterNearbyDateRange({
			commit
		}, dates) {
			let x = 0;
			for (x = 0; x < this.getters["map/nearbyPolylines"].length; x++) {
				if (this.getters["map/nearbyPolylines"][x]) {
					if (dates.fromDate != null && dates.toDate != null) {
						var startDate = Vue.prototype.moment(dates.fromDate);
						var endDate = Vue.prototype.moment(dates.toDate);

						startDate.hours(0);
						startDate.minutes(0);
						startDate.seconds(0);
						endDate.hours(23);
						endDate.minutes(59);
						endDate.seconds(59);

						// console.log("---------------------------------------------");
						// console.log(this.getters["map/nearbyPolylines"][x].blockData.streetName);
						// console.log(this.getters["map/nearbyPolylines"][x].fromDate);
						// console.log(this.getters["map/nearbyPolylines"][x].toDate);
						var testStart = Vue.prototype.moment(this.getters["map/nearbyPolylines"][x].fromDate);
						var testEnd = Vue.prototype.moment(this.getters["map/nearbyPolylines"][x].toDate);
						// commit('setFromDate', startDate);
						// commit('setToDate', endDate);
						if (
							testStart.isBetween(startDate, endDate, 'hours', true) ||
							testEnd.isBetween(startDate, endDate, 'hours', true) ||
							(testStart.isBefore(endDate, 'hours', true) && testEnd.isAfter(endDate, 'hours', true))

						) {
							this.getters["map/nearbyPolylines"][x].setOptions({
								strokeOpacity: 1
							});
						} else {
							this.getters["map/nearbyPolylines"][x].setOptions({
								strokeOpacity: 0
							});
						}
					} else {
						commit('setFromDate', null);
						commit('setToDate', null);
						this.getters["map/nearbyPolylines"][x].setOptions({
							strokeOpacity: 1
						});
					}
				}
			}
		},



		filterByDateRange({
			commit
		}, dates) {
			let x = 0;
			for (x = 0; x < this.getters["map/polylines"].length; x++) {
				if (this.getters["map/polylines"][x]) {
					if (this.getters["map/polylines"][x].laneClosureRequest) {
						if (dates.fromDate != null && dates.toDate != null) {
							var startDate = Vue.prototype.moment(dates.fromDate);
							var endDate = Vue.prototype.moment(dates.toDate);

							startDate.hours(0);
							startDate.minutes(0);
							startDate.seconds(0);
							endDate.hours(23);
							endDate.minutes(59);
							endDate.seconds(59);

							var testStart = Vue.prototype.moment(this.getters["map/polylines"][x].laneClosureRequest.fromDate);
							var testEnd = Vue.prototype.moment(this.getters["map/polylines"][x].laneClosureRequest.toDate);

							commit('setFromDate', startDate);
							commit('setToDate', endDate);

							if (
								testStart.isBetween(startDate, endDate, 'hours', true) ||
								testEnd.isBetween(startDate, endDate, 'hours', true) ||
								(testStart.isBefore(endDate, 'hours', true) && testEnd.isAfter(endDate, 'hours', true))

							) {
								this.getters["map/polylines"][x].setOptions({
									strokeOpacity: 1
								});
							} else {
								this.getters["map/polylines"][x].setOptions({
									strokeOpacity: 0
								});
							}
						} else {
							commit('setFromDate', null);
							commit('setToDate', null);
							this.getters["map/polylines"][x].setOptions({
								strokeOpacity: 1
							});
						}
					}
				}
			}
		},
		filterByDateRangePlus3Days({
			commit
		}, dates) {
			let x = 0;
			for (x = 0; x < this.getters["map/polylines"].length; x++) {
				if (this.getters["map/polylines"][x]) {
					if (this.getters["map/polylines"][x].laneClosureRequest) {
						if (dates.fromDate != null && dates.toDate != null) {
							var startDate = Vue.prototype.moment(dates.fromDate);
							var endDate = Vue.prototype.moment(dates.toDate);
							var testStart = Vue.prototype.moment(this.getters["map/polylines"][x].laneClosureRequest.fromDate);
							var testEnd = Vue.prototype.moment(this.getters["map/polylines"][x].laneClosureRequest.toDate);

							startDate = Format.subtractWeekdays(startDate, 3);
							endDate = Format.addWeekdays(endDate, 3);

							commit('setFromDate', startDate);
							commit('setToDate', endDate);

							if (testStart.isBetween(startDate, endDate, 'days', true) || testEnd.isBetween(startDate, endDate, 'days', true)) {
								this.getters["map/polylines"][x].setOptions({
									strokeOpacity: 1
								});
							} else {
								this.getters["map/polylines"][x].setOptions({
									strokeOpacity: 0
								});
							}
						} else {
							commit('setFromDate', null);
							commit('setToDate', null);

							this.getters["map/polylines"][x].setOptions({
								strokeOpacity: 1
							});
						}
					}
				}
			}
		},



		zoomToBlockIdPopup({
			commit
		}, id) {
			var bounds = new google.maps.LatLngBounds();
			// let setBounds = false;
			let recordIndex = null;
			let infoWindowLatLng = null;

			let x = 0;
			let z = 0;
			for (x = 0; x < this.getters["map/polylines"].length; x++) {
				if (this.getters["map/polylines"][x]) {
					if (this.getters["map/polylines"][x].blockData) {
						if (this.getters["map/polylines"][x].blockData.blockId == id) {
							recordIndex = x;
							let polyBounds = this.getters["map/polylines"][x].getPath();
							commit('setPolylineMaxZIndex', x);
							for (z = 0; z < polyBounds.length; z++) {
								bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
								if (infoWindowLatLng == null) {
									infoWindowLatLng = polyBounds.getAt(z);
								}
							}
							// setBounds = true;
						}
					}
				}
			}
			if (recordIndex != null) {
				Vue.prototype.$bus.$emit('map:block-polyline-click', this.getters["map/polylines"][recordIndex], null);
			}


			// var startLatLng = startMarker.getPosition();
			// var endLatLng = endMarker.getPosition();
			// var startPoint = projection.fromLatLngToPoint(startLatLng);
			// var endPoint = projection.fromLatLngToPoint(endLatLng);
			// // Average
			// var midPoint = new google.maps.Point(
			//     (startPoint.x + endPoint.x) / 2,
			//     (startPoint.y + endPoint.y) / 2);
			// // Unproject
			// var midLatLng = projection.fromPointToLatLng(midPoint);
			// var midMarker = createMarker(midLatLng, "text");

			// if (setBounds) {
			// 	commit('fitBounds', bounds);
			// }

			/*
			if (setBounds) {
				Vue.prototype.$bus.$emit('map:block-picker-popup', {
					polyline: this.getters["map/polylines"][recordIndex],
					e: {
						latLng: infoWindowLatLng
					}
				});
				commit('fitBounds', bounds);
				Vue.prototype.$bus.$emit("map:setMapDateFields", "all");

			}
			*/
		},


		bringPolylineToTop({
			commit
		}, x) {
			if (this.getters["map/polylines"][x]) {
				commit('setPolylineMaxZIndex', x);
			}
		},

		bringLcrPolylinesToTop({
			commit
		}, lcrId) {
			var x = 0;
			for (x = 0; x < this.getters["map/polylines"].length; x++) {
				if (this.getters["map/polylines"][x].laneClosureRequest) {
					if (this.getters["map/polylines"][x].laneClosureRequest.id == lcrId) {
						commit('setPolylineMaxZIndex', x);
					}
				}
			}
		},


		bringLcrNearbyPolylinesToTop({
			commit
		}, {lcrId:lcrId, routeName:routeName}) {
			var x = 0;
			var hideOthers = false;
			if (routeName == "home"
				|| routeName == "LaneClosureList"
				|| routeName == "ReportClosureSearch"
				|| routeName == "ReportRestrictionSearch"
				|| routeName == "ReportContraventionSearch"
				) {
				hideOthers = true;
			}
			// not hiding for now...
			hideOthers = false;

			for (x = 0; x < this.getters["map/nearbyPolylines"].length; x++) {
				if (this.getters["map/nearbyPolylines"][x].laneClosureRequest) {
					if (this.getters["map/nearbyPolylines"][x].laneClosureRequest.id == lcrId) {
						commit('setNearbyPolylineMaxZIndex', x);
						if (hideOthers) {
							commit('setNearbyPolylineShow', x);
						}
					} else {
						if (hideOthers) {
							commit('setNearbyPolylineHide', x);
						}
					}
				}
			}
		},




		zoomToLaneClosureRequestId({
			commit
		}, id) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;

			let recordIndex = null;
			let infoWindowLatLng = null;
			let x = 0;
			for (x = 0; x < this.getters["map/polylines"].length; x++) {
				if (this.getters["map/polylines"][x]) {
					if (this.getters["map/polylines"][x].laneClosureRequest) {
						if (this.getters["map/polylines"][x].laneClosureRequest.id == id) {
							recordIndex = x;
							let polyBounds = this.getters["map/polylines"][x].getPath();
							for (let z = 0; z < polyBounds.length; z++) {
								bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
								if (infoWindowLatLng == null) {
									infoWindowLatLng = polyBounds.getAt(z);
								}
							}
							setBounds = true;
						}
					}
				}
			}
			if (setBounds) {
				commit('fitBounds', bounds);
				Vue.prototype.$bus.$emit('map:block-popup', {
					polyline: this.getters["map/polylines"][recordIndex],
					e: {
						latLng: infoWindowLatLng
					}
				});
				Vue.prototype.$bus.$emit("map:setMapDateFields", "all");
			} else {
				// zoom to nearby maybe...
				this.dispatch('map/zoomToNearbyRequestById', id);
			}

		},

		getBoundsByNearbyRequestId({
			commit
		}, id) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			let x = 0;
			for (x = 0; x < this.getters["map/nearbyPolylines"].length; x++) {
				if (this.getters["map/nearbyPolylines"][x]) {
					if (this.getters["map/nearbyPolylines"][x].laneClosureRequest) {
						if (this.getters["map/nearbyPolylines"][x].laneClosureRequest.id == id) {
							let polyBounds = this.getters["map/nearbyPolylines"][x].getPath();
							for (let z = 0; z < polyBounds.length; z++) {
								bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
							}
						}
						setBounds = true;
					}
				}
			}
			if (!setBounds) {
				// just zoom all the blocks then...
				bounds = new google.maps.LatLngBounds();
				let x = 0;
				let z = 0;
				for (x = 0; x < this.getters["map/polylines"].length; x++) {
					if (this.getters["map/polylines"][x]) {
						let polyBounds = this.getters["map/polylines"][x].getPath();
						for (z = 0; z < polyBounds.length; z++) {
							bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
						}
					}
				}
			}
			commit('fitBounds', bounds);
		},

		setLoadNearbyBounds({
			commit
		}, flag) {
			commit('setLoadNearbyBounds', flag);
		},


		setNearbyBounds({
			commit
		}, bounds) {
			commit('setNearbyBounds', bounds);
		},


		zoomToNearbyRequestById({
			commit
		}, id) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;

			let recordIndex = null;
			let infoWindowLatLng = null;
			let x = 0;
			for (x = 0; x < this.getters["map/nearbyPolylines"].length; x++) {
				if (this.getters["map/nearbyPolylines"][x]) {
					if (this.getters["map/nearbyPolylines"][x].laneClosureRequest) {
						if (this.getters["map/nearbyPolylines"][x].laneClosureRequest.id == id) {
							recordIndex = x;
							let polyBounds = this.getters["map/nearbyPolylines"][x].getPath();
							commit('setNearbyPolylineMaxZIndex', x);
							for (let z = 0; z < polyBounds.length; z++) {
								bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
								if (infoWindowLatLng == null) {
									infoWindowLatLng = polyBounds.getAt(z);
								}
							}
						}
						setBounds = true;
					}
				}
			}
			if (setBounds) {
				// console.log("fit bounds 1");
				commit('fitBounds', bounds);
				Vue.prototype.$bus.$emit('map:nearby-block-popup', {
					polyline: this.getters["map/nearbyPolylines"][recordIndex],
					e: {
						latLng: infoWindowLatLng
					}
				});

				// commit('setLcrFromDate', Vue.prototype.moment(this.getters["map/nearbyPolylines"][recordIndex].laneClosureRequest.fromDate));
				// commit('setLcrToDate', Vue.prototype.moment(this.getters["map/nearbyPolylines"][recordIndex].laneClosureRequest.toDate));
				// this.dispatch("map/filterByDateRangePlus3Days", {
				// 	fromDate: this.getters["map/nearbyPolylines"][recordIndex].laneClosureRequest.fromDate,
				// 	toDate: this.getters["map/nearbyPolylines"][recordIndex].laneClosureRequest.toDate
				// });

				// Vue.prototype.$bus.$emit("map:setMapDateFields", "all");

			} else {
				// just zoom all the blocks then...
				bounds = new google.maps.LatLngBounds();
				let setBounds = false;
				let x = 0;
				let z = 0;
				for (x = 0; x < this.getters["map/polylines"].length; x++) {
					if (this.getters["map/polylines"][x]) {
						let polyBounds = this.getters["map/polylines"][x].getPath();
						for (z = 0; z < polyBounds.length; z++) {
							bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
						}
						setBounds = true;
					}
				}
				if (setBounds) {
					// console.log("fit bounds 2");
					// console.log(bounds);
					commit('fitBounds', bounds);
				} else {
					if (this.getters["map/zoom"] <= 3 && !this.getters["map/zoomFixed"]) {
						commit('setZoomFixed', true);
						commit('setZoom', 16);
						commit('setCenter', 49.895077, -97.138451);
					}
				}
			}
		},



		panToLaneClosureRequestId({
			commit
		}, id) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;

			let recordIndex = null;
			let infoWindowLatLng = null;
			let x = 0;
			for (x = 0; x < this.getters["map/polylines"].length; x++) {
				if (this.getters["map/polylines"][x]) {
					if (this.getters["map/polylines"][x].laneClosureRequest) {
						if (this.getters["map/polylines"][x].laneClosureRequest.id == id) {
							recordIndex = x;
							let polyBounds = this.getters["map/polylines"][x].getPath();
							for (let z = 0; z < polyBounds.length; z++) {
								bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
								if (infoWindowLatLng == null) {
									infoWindowLatLng = polyBounds.getAt(z);
								}
							}
							setBounds = true;
						}
					}
				}
			}
			if (setBounds) {
				// commit('fitBounds', bounds);

				Vue.prototype.$bus.$emit('map:block-popup', {
					polyline: this.getters["map/polylines"][recordIndex],
					e: {
						latLng: infoWindowLatLng
					}
				});
				Vue.prototype.$bus.$emit("map:setMapDateFields", "all");
			} else {
				// zoom to nearby maybe...
				this.dispatch('map/panToNearbyRequestById', id);
			}

		},

		panToNearbyLaneClosureRequestId({
			commit
		}, id) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;

			let recordIndex = null;
			let infoWindowLatLng = null;
			let x = 0;

			for (x = 0; x < this.getters["map/nearbyPolylines"].length; x++) {
				if (this.getters["map/nearbyPolylines"][x]) {
					if (this.getters["map/nearbyPolylines"][x].laneClosureRequest) {
						if (this.getters["map/nearbyPolylines"][x].laneClosureRequest.id == id) {
							recordIndex = x;
							let polyBounds = this.getters["map/nearbyPolylines"][x].getPath();
							commit('setNearbyPolylineMaxZIndex', x);
							for (let z = 0; z < polyBounds.length; z++) {
								bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
								if (infoWindowLatLng == null) {
									infoWindowLatLng = polyBounds.getAt(z);
								}
							}
						}
						setBounds = true;
					}
				}
			}
			if (setBounds) {
				// commit('fitBounds', bounds);

				Vue.prototype.$bus.$emit('map:nearby-block-popup', {
					polyline: this.getters["map/nearbyPolylines"][recordIndex],
					e: {
						latLng: infoWindowLatLng
					}
				});

				// commit('setLcrFromDate', Vue.prototype.moment(this.getters["map/nearbyPolylines"][recordIndex].laneClosureRequest.fromDate));
				// commit('setLcrToDate', Vue.prototype.moment(this.getters["map/nearbyPolylines"][recordIndex].laneClosureRequest.toDate));
				// this.dispatch("map/filterByDateRangePlus3Days", {
				// 	fromDate: this.getters["map/nearbyPolylines"][recordIndex].laneClosureRequest.fromDate,
				// 	toDate: this.getters["map/nearbyPolylines"][recordIndex].laneClosureRequest.toDate
				// });

				// Vue.prototype.$bus.$emit("map:setMapDateFields", "all");

			}
		},



		setAllNearbyBlockPolylineColour({
			commit
		}, i) {
			let polyline = null;
			if (this.getters["map/nearbyPolylines"]) {
				for (var index = 0; index < this.getters["map/nearbyPolylines"]; index++) {
					if (this.getters["map/nearbyPolylines"][index]) {
						polyline = this.getters["map/nearbyPolylines"][index];

						if (polyline.defaultOptions) {
							if (polyline.defaultOptions.strokeColor == "#293C7C") {
								console.log("we have a blue!");
								console.log(index);
								console.log(polyline);
							}

							polyline.setOptions({
								strokeColor: polyline.defaultOptions.strokeColor,
								strokeOpacity: polyline.defaultOptions.strokeOpacity,
								// strokeWeight: polyline.defaultOptions.strokeWeight
							});
							polyline.textColor = polyline.defaultOptions.textColor;
							if (polyline.defaultOptions.strokeColor != "#000000") {
								continue;
							}
						}

						let textColor = "#ffffff";
						let color = "#000000";
						let opacity = 1.0;
						// let weight = 8;
						if (polyline.laneClosureRequest.approvalStatusId == 1) {
							// pending
							color = "#009900";
							opacity = 1.0;
							// weight = 6;
						}
						if (polyline.laneClosureRequest.approvalStatusId == 2) {
							// see if any of the
							// active
							if (polyline.laneClosureRequest.closureActiveStatusId == 2 || polyline.laneClosureRequest.restrictionActiveStatusId == 2) {
								color = "#ff7314";
								if (polyline.laneClosureRequest.block) {
									color = "#ff7314";
									let i = 0;
									for (i = 0; i < polyline.laneClosureRequest.block.length; i++) {
										if (polyline.laneClosureRequest.block[i].lane) {
											for (let j = 0; j < polyline.laneClosureRequest.block[i].lane.length; j++) {
												// complete closure of street / direction
												if (polyline.laneClosureRequest.block[i].lane[j].laneId == 13 ||
													polyline.laneClosureRequest.block[i].lane[j].laneId == 14) {
													color = "#ed1c24";
												}
											}
										}
									}
								}
							} else {
								// Approved and Planned (upcoming)
								if (polyline.laneClosureRequest.closureActiveStatusId == 1 || polyline.laneClosureRequest.restrictionActiveStatusId == 1) {
									color = "#ffff00";
									textColor = "#000000";
								}
							}
						}
						if (polyline.laneClosureRequest.recordStatusId == 6) {
							// expired
							color = "#990000";
							opacity = 1.0;
							// weight = 6;
						}
						if (polyline.laneClosureRequest.recordStatusId == 7) {
							// completed
							color = "#666666";
							opacity = 1.0;
							// weight = 6;
						}
						if (polyline.laneClosureRequest.approvalStatusId == 3) {
							// denied
							color = "#FF0000";
						}
						if (polyline.laneClosureRequest.id == this.getters["map/activeLcrId"]) {
							color = "#283C80";
							opacity = 1.0;
							// lets find blocks that are intersecting...
							// var hasOverlap = 0;
							// for (var z = 0; z < this.getters["map/nearbyPolylines"].length; z++) {
							// 	if (this.getters["map/nearbyPolylines"][z].blockId == polyline.blockId) {
							// 		if (this.getters["map/nearbyPolylines"][z].laneClosureRequest.id != polyline.laneClosureRequest.id) {
							// 			// color = "#eeeeee";
							// 			hasOverlap = 1;
							// 		}
							// 	}
							// }
							// if (hasOverlap) {
							// 	color = "#52a5d7";
							// }
						}

						if (color == "#cccccc") {
							// console.log("recordStatusId:" + polyline.laneClosureRequest.recordStatusId);
							// console.log("approvalStatusId:" + polyline.laneClosureRequest.approvalStatusId);
							// console.log("closureActiveStatusId:" + polyline.laneClosureRequest.closureActiveStatusId);
							// console.log("restrictionActiveStatusId:" + polyline.laneClosureRequest.restrictionActiveStatusId);
						}
						polyline.setOptions({
							strokeColor: color,
							strokeOpacity: opacity,
							// strokeWeight: weight
						});

						polyline.defaultOptions = {
							strokeColor: color,
							strokeOpacity: opacity,
							// strokeWeight: weight,
							textColor: textColor
						}
						polyline.textColor = textColor;


					}
				}
			}

		},


		setNearbyBlockPolylineColour({
			commit
		}, index) {
			let polyline = null;
			if (this.getters["map/nearbyPolylines"][index]) {
				polyline = this.getters["map/nearbyPolylines"][index];

				if (polyline.defaultOptions) {
					polyline.setOptions({
						strokeColor: polyline.defaultOptions.strokeColor,
						strokeOpacity: polyline.defaultOptions.strokeOpacity,
						// strokeWeight: polyline.defaultOptions.strokeWeight
					});
					polyline.textColor = polyline.defaultOptions.textColor;
					if (polyline.defaultOptions.strokeColor != "#000000") {
						return;
					}
				}

				let textColor = "#ffffff";
				let color = "#000000";
				let opacity = 1.0;
				// let weight = 8;
				if (polyline.laneClosureRequest.approvalStatusId == 1) {
					// pending
					color = "#009900";
					opacity = 1.0;
					// weight = 6;
				}
				if (polyline.laneClosureRequest.approvalStatusId == 2) {
					// see if any of the
					// active
					if (polyline.laneClosureRequest.closureActiveStatusId == 2 || polyline.laneClosureRequest.restrictionActiveStatusId == 2) {
						color = "#ff7314";
						if (polyline.laneClosureRequest.block) {
							color = "#ff7314";
							let i = 0;
							for (i = 0; i < polyline.laneClosureRequest.block.length; i++) {
								if (polyline.laneClosureRequest.block[i].lane) {
									for (let j = 0; j < polyline.laneClosureRequest.block[i].lane.length; j++) {
										// complete closure of street / direction
										if (polyline.laneClosureRequest.block[i].lane[j].laneId == 13 ||
											polyline.laneClosureRequest.block[i].lane[j].laneId == 14) {
											color = "#ed1c24";
										}
									}
								}
							}
						}
					} else {
						// Approved and Planned (upcoming)
						if (polyline.laneClosureRequest.closureActiveStatusId == 1 || polyline.laneClosureRequest.restrictionActiveStatusId == 1) {
							color = "#ffff00";
							textColor = "#000000";
						}
					}
				}
				if (polyline.laneClosureRequest.recordStatusId == 6) {
					// expired
					color = "#990000";
					opacity = 1.0;
					// weight = 6;
				}
				if (polyline.laneClosureRequest.recordStatusId == 7) {
					// completed
					color = "#666666";
					opacity = 1.0;
					// weight = 6;
				}
				if (polyline.laneClosureRequest.approvalStatusId == 3) {
					// denied
					color = "#FF0000";
				}
				if (polyline.laneClosureRequest.id == this.getters["map/activeLcrId"]) {
					color = "#283C80";
					opacity = 1.0;
					// lets find blocks that are intersecting...
					// var hasOverlap = 0;
					// for (var z = 0; z < this.getters["map/nearbyPolylines"].length; z++) {
					// 	if (this.getters["map/nearbyPolylines"][z].blockId == polyline.blockId) {
					// 		if (this.getters["map/nearbyPolylines"][z].laneClosureRequest.id != polyline.laneClosureRequest.id) {
					// 			// color = "#eeeeee";
					// 			hasOverlap = 1;
					// 		}
					// 	}
					// }
					// if (hasOverlap) {
					// 	color = "#52a5d7";
					// }
				}

				if (color == "#cccccc") {
					// console.log("recordStatusId:" + polyline.laneClosureRequest.recordStatusId);
					// console.log("approvalStatusId:" + polyline.laneClosureRequest.approvalStatusId);
					// console.log("closureActiveStatusId:" + polyline.laneClosureRequest.closureActiveStatusId);
					// console.log("restrictionActiveStatusId:" + polyline.laneClosureRequest.restrictionActiveStatusId);
				}
				polyline.setOptions({
					strokeColor: color,
					strokeOpacity: opacity,
					// strokeWeight: weight
				});

				polyline.defaultOptions = {
					strokeColor: color,
					strokeOpacity: opacity,
					// strokeWeight: weight,
					textColor: textColor
				}
				polyline.textColor = textColor;


			}
		},

		setAllBlockPolylineColours({
			commit
		}) {
			if (this.getters["map/polylines"]) {
				for (var x = 0; x < this.getters["map/polylines"]; x++) {
					this.dispatch("map/setBlockPolylineColour", x);
				}
			}
		},




		setBlockPolylineColour({
			commit
		}, index) {
			let polyline = null;
			if (this.getters["map/polylines"][index]) {
				polyline = this.getters["map/polylines"][index];
				if (polyline.defaultOptions) {
					polyline.setOptions({
						strokeColor: polyline.defaultOptions.strokeColor,
						strokeOpacity: polyline.defaultOptions.strokeOpacity,
						strokeWeight: polyline.defaultOptions.strokeWeight
					});
					return;
				}


				let color = "#000000";
				let opacity = 1.0;
				let weight = 8;
				if (typeof polyline.laneClosureRequest != "undefined") {
				if (polyline.laneClosureRequest.approvalStatusId == 1) {
					// pending
					color = "#009900";
					opacity = 1.0;
					weight = 6;
				}
				if (polyline.laneClosureRequest.approvalStatusId == 2) {
					// see if any of the
					// active
					if (polyline.laneClosureRequest.closureActiveStatusId == 2 || polyline.laneClosureRequest.restrictionActiveStatusId == 2) {
						if (polyline.laneClosureRequest.block) {
							color = "#ff7314";
							let i = 0;
							for (i = 0; i < polyline.laneClosureRequest.block.length; i++) {
								if (polyline.laneClosureRequest.block[i].lane) {
									for (let j = 0; j < polyline.laneClosureRequest.block[i].lane.length; j++) {
										// complete closure of street / direction
										if (polyline.laneClosureRequest.block[i].lane[j].laneId == 13 ||
											polyline.laneClosureRequest.block[i].lane[j].laneId == 14) {
											color = "#ed1c24";
										}
									}
								}
							}
						}
					} else {
						// Approved and Planned (upcoming)
						if (polyline.laneClosureRequest.closureActiveStatusId == 1 || polyline.laneClosureRequest.restrictionActiveStatusId == 1) {
							color = "#ffff00";
						}
					}
				}
				if (polyline.laneClosureRequest.recordStatusId == 6) {
					// expired
					color = "#990000";
					opacity = 1.0;
					weight = 6;
				}
				if (polyline.laneClosureRequest.recordStatusId == 7) {
					// completed
					color = "#666666";
					opacity = 1.0;
					weight = 6;
				}
				if (polyline.laneClosureRequest.approvalStatusId == 3) {
					// denied
				}

				/*
				if (polyline.laneClosureRequest.id == this.getters["map/activeLcrId"]) {
					color = "#283C80";
					opacity = 1.0;
					// lets find blocks that are intersecting...
					var hasOverlap = 0;
					for (var z = 0; z < this.getters["map/polylines"].length; z++) {
						if (this.getters["map/polylines"][z].blockId == polyline.blockId) {
							if (this.getters["map/polylines"][z].laneClosureRequest.id != polyline.laneClosureRequest.id) {
								// color = "#eeeeee";
								hasOverlap = 1;
							}
						}
					}
					if (hasOverlap) {
						// color = "#52a5d7";
					}
				}
				*/

				let testId = null;
				// let bIndex = null;
				let i = 0;
				for (i = 0; i < polyline.laneClosureRequest.block.length; i++) {
					if (polyline.laneClosureRequest.block[i].id) {
						testId = polyline.laneClosureRequest.block[i].id;
						if (this.getters["map/blockRequests"].findIndex(z => z.id === testId)) {
							// weight: 100;
						}
					}
				}
				} else {
					console.log(polyline);
				}



				polyline.setOptions({
					strokeColor: color,
					strokeOpacity: opacity,
					strokeWeight: weight
				});

				polyline.defaultOptions = {
					strokeColor: color,
					strokeOpacity: opacity,
					strokeWeight: weight
				}
			}
		},


		setPolylineStyleForDirections({
			commit
		}, index) {
			if (this.getters["map/polylines"][index]) {
				let color = "#000000";
				let opacity = 1.0;
				// let weight = 8;
				let block = this.getters["map/polylines"][index].blockData;
				if (block.directionId == null || block.directionId == 0) {
					color = "#000000";
				}
				// Northbound
				if (block.directionId == 1) {
					color = "#237bd4"; // #0619f0
				}
				// Southbound
				if (block.directionId == 2) {
					color = "#db8024";
				}
				// Eastbound
				if (block.directionId == 3) {
					color = "#d4237b";
				}
				// Westbound
				if (block.directionId == 4) {
					color = "#23d47b"; // #ff1e00";
				}
				// Eastbound and Westbound
				if (block.directionId == 5) {
					color = "#0000ff"; // #ff0062";
				}
				// Northbound and Southbound
				if (block.directionId == 6) {
					color = "#ff0000";
				}
				if (block.westboundLat == null && block.eastboundLat == null && block.northboundLat == null && block.southboundLat == null) {
					// color = "#EA6220";
				}
				if (block.directionId == 0) {

					this.getters["map/polylines"][index].setOptions({
						strokeColor: color,
						strokeOpacity: opacity
							// ,strokeWeight: weight

					});
					/*
					icons: [{
						icon: {
							path: 'M 0,-1 0,1',
							strokeOpacity: 1,
							scale: 2
						},
						offset: '0',
						repeat: '10px'
					  }],
					*/

				} else {
					this.getters["map/polylines"][index].setOptions({
						strokeColor: color,
						strokeOpacity: opacity
							// ,strokeWeight: weight
					});
				}
			}
		},



		setPolylineStyleForFixingMedianTurns({
			commit
		}, index) {
			if (this.getters["map/polylines"][index]) {
				let color = "#000000";
				let opacity = 1.0;
				// let weight = 8;
				let block = this.getters["map/polylines"][index].blockData;
				if (block.directionId == null || block.directionId == 0) {
					color = "#000000"; // need direction
				} else {
					color = "#23f0ff"; // good...
					if (block.fromStreet == block.toStreet) {
						if (
							block.southboundLeft != null ||
							block.southboundRight != null ||
							block.northboundLeft != null ||
							block.northboundRight != null ||
							block.eastboundLeft != null ||
							block.eastboundRight != null ||
							block.westboundLeft != null ||
							block.westboundRight != null) {
							color = "#ff238a";
						} else {
							color = "#ffcc23"; // good...
						}
					}
				}

				if (block.directionId == 0) {

					this.getters["map/polylines"][index].setOptions({
						strokeColor: color,
						strokeOpacity: opacity
							// ,strokeWeight: weight

					});
				} else {
					this.getters["map/polylines"][index].setOptions({
						strokeColor: color,
						strokeOpacity: opacity
							// ,strokeWeight: weight
					});
				}
			}
		},


		// setPolylineColours(index) {
		// let x = 0;
		// // for(x =0; x < this.value.length; x++) {
		// // 	if (this.value[x].mapPolyline) {
		// // 		this.value[x].mapPolyline.setOptions({strokeColor:'#666666'});
		// // 		if (x == index) {
		// // 			this.value[x].mapPolyline.setOptions({strokeColor:'#293C7C'});
		// // 		}
		// // 	}
		// // }

		// 	for (x =0; x < this.getters["map/polylines"].length; x++) {
		// 		if (this.$store.getters["map/polylines"][x]) {
		// 			if (this.$store.getters["map/polylines"][x].blockData) {
		// 				if (this.$store.getters["map/polylines"][x].blockData.blockId == this.value[index].blockId) {
		// 					this.$store.getters["map/polylines"][x].setOptions({strokeColor:'#293C7C'});
		// 				} else {
		// 					this.$store.getters["map/polylines"][x].setOptions({strokeColor:'#666666'});
		// 				}
		// 			}
		// 		}
		// 	}

		// },

		async resetForEditing({
			commit,
			rootState
		}, params = Object()) {
			commit('clearNearbyPolylines', {});
			commit('clearMarkers', {});
		},

		async hideNearby({
			commit,
			rootState
		}, params = Object()) {
			commit('clearNearbyPolylines', {});
		},

		async loadNearby({
			commit,
			rootState
		}, params = Object()) {
			/*
			params = {
				NorthEastLat: this.state.map.map.getBounds().getNorthEast().lat(),
				NorthEastLon: this.state.map.map.getBounds().getNorthEast().lng(),
				SouthWestLat: this.state.map.map.getBounds().getSouthWest().lat(),
				SouthWestLon: this.state.map.map.getBounds().getSouthWest().lng(),
			}
			if (this.state.map.fromDate) {
				this.state.map.fromDate.minutes(0);
				this.state.map.fromDate.hours(0);
				params.fromDateTime = this.state.map.fromDate.format();
			}
			if (this.state.map.toDate) {
				this.state.map.toDate.minutes(59);
				this.state.map.toDate.hours(23);
				params.toDateTime = this.state.map.toDate.format();
			} else {

			}
			*/
			params.perPage = 999;
			params.page = 1;
			params.completed = 0;
			// console.log(params);
			Vue.prototype.$bus.$emit('map:loading', true);
			Vue.prototype.$bus.$emit('map:nearbyLoading', true);
			let res = await Vue.prototype.$http.post(rootState.apiUrl + '/lane-closure-request/list-for-view/', params)
			commit('loadNearbySuccess', res.data)
			Vue.prototype.$bus.$emit('map:loading', false);
			Vue.prototype.$bus.$emit('map:nearbyLoaded', true);
		},


		async loadNearbyBounded({
			commit,
			rootState
		}, params = Object()) {
			params.perPage = 999;
			params.page = 1;
			params.completed = 0;
			params.excludeLcrId = [];
			var x = 0;
			// attach the exisitng polyline request ids so that we don't select them in the database.
			if (this.getters["map/nearbyPolylines"]) {
				for (x = 0; x < this.getters["map/nearbyPolylines"].length; x++) {
					if (typeof this.getters["map/nearbyPolylines"][x] != "undefined") {
						if (!params.excludeLcrId.includes(this.getters["map/nearbyPolylines"][x].lcrId)) {
							params.excludeLcrId.push(this.getters["map/nearbyPolylines"][x].lcrId);
						}
					}
				}
			}

			// console.log(params);
			Vue.prototype.$bus.$emit('map:loading', true);
			Vue.prototype.$bus.$emit('map:nearbyLoading', true);
			let res = await Vue.prototype.$http.post(rootState.apiUrl + '/lane-closure-request/list-for-view/', params)
			commit('loadNearbyBoundedSuccess', res.data)
		},


		async loadNearbyIfEmpty({
			commit,
			rootState
		}, params = Object()) {
			/*
			params = {
				NorthEastLat: this.state.map.map.getBounds().getNorthEast().lat(),
				NorthEastLon: this.state.map.map.getBounds().getNorthEast().lng(),
				SouthWestLat: this.state.map.map.getBounds().getSouthWest().lat(),
				SouthWestLon: this.state.map.map.getBounds().getSouthWest().lng(),
			}
			if (this.state.map.fromDate) {
				this.state.map.fromDate.minutes(0);
				this.state.map.fromDate.hours(0);
				params.fromDateTime = this.state.map.fromDate.format();
			}
			if (this.state.map.toDate) {
				this.state.map.toDate.minutes(59);
				this.state.map.toDate.hours(23);
				params.toDateTime = this.state.map.toDate.format();
			} else {

			}
			*/
			if (this.state.nearbyPolylines) {
				if (this.state.nearbyPolylines.length == 0) {
					Vue.prototype.$bus.$emit('map:loading', true);
					let res = await Vue.prototype.$http.post(rootState.apiUrl + '/lane-closure-request/list/', params)
					commit('loadNearbySuccess', res.data)
					Vue.prototype.$bus.$emit('map:loading', false);
				}
			}

		},



	}

}